import { useCallback } from 'react';
import { Formik } from 'formik';
import PropTypes from 'prop-types';

import FormCard from 'src/components/ui/FormCard';

import DefaultForm from '../DefaultForm';
import { useFormAreaName } from '../hooks/useFormAreaName';

const DefaultFormCAreaName = (props) => {
	const {
		isPlain,
		onSubmit,
		onCancel,
		serverError,
		fullHeight,
		initialData,
		...rest
	} = props;

	const handleSubmit = useCallback(
		async (values) => {
			if (onSubmit) {
				await onSubmit(values);
			}
		},
		[onSubmit],
	);

	const { shape, initialValues, validationSchema } = useFormAreaName({
		values: { name: initialData?.name ?? '' },
	});

	const form = <DefaultForm {...shape} {...rest} />;

	if (isPlain) return form;

	let result = (
		<Formik
			onSubmit={handleSubmit}
			initialValues={initialValues}
			validationSchema={validationSchema}
			validateOnChange={false}
			enableReinitialize
		>
			{(formikProps) => {
				return (
					<FormCard
						title="Изменить название"
						acceptLabel="Изменить"
						fullHeight={fullHeight}
						error={serverError}
						onSubmit={formikProps.handleSubmit}
						onCancel={onCancel}
						onAccept={formikProps.submitForm}
						isLoading={formikProps.isSubmitting}
					>
						{form}
					</FormCard>
				);
			}}
		</Formik>
	);

	return result;
};

DefaultFormCAreaName.propTypes = {
	...DefaultForm.propTypes,
	isPlain: PropTypes.bool,
	onSubmit: PropTypes.func,
	serverError: PropTypes.string,
	fullHeight: PropTypes.bool,
	initialData: PropTypes.shape({
		name: PropTypes.string,
	}),
};

export default DefaultFormCAreaName;
